export default "__VITE_ASSET__BF7Kg6os__"